import styled from 'styled-components/macro';
import { Col } from '@yme/atoms/grid';
import { Image } from '@yme/atoms/image';
import { colorBrandYamahaRed } from '@yme/tokens/colors';
import { ADAPTIVE } from '@yme/tokens/screen';
import { INDENT } from '@yme/tokens/sizes';
export const ImageStyled = styled(Image) `
  margin-bottom: ${INDENT.xs};

  ${ADAPTIVE.minWidth.tablet} {
    margin-bottom: 0;
  }
`;
export const DescriptionStyled = styled(Col) `
  ${({ isRightToLeft }) => isRightToLeft && 'direction: rtl;'}
`;
export const DividerStyled = styled.div `
  width: 56px;
  border-width: 0;
  border-style: solid;
  border-top-width: 2px;
  border-color: ${colorBrandYamahaRed};
  margin-bottom: ${INDENT.xxxs};
`;
